// extracted by mini-css-extract-plugin
export default {"option":"FontFamilySelect_option__RHGzW"};